module.exports = __webpack_public_path__ + "img/violet_007.38d7a818.png";